module.exports = __webpack_public_path__ + "img/roof-repair-exterior-maintenance-06-tablet.dcca4dee.jpg";